import { useEffect } from "react";

export const useBeforeUnloadPrompt = (
    shouldBlock: boolean,
    message: string
) => {
    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if ((window as any).isLoggingOut) return;
            if (!shouldBlock) return;
            sessionStorage.setItem("reloaded", "true"); // flag for next load
            e.preventDefault();
            e.returnValue = message;
            return message;
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () =>
            window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [shouldBlock, message]);
};
